export default __webpack_public_path__ + "assets/images/d1f2520fb8b2d9415cc6192c9afe0a26.jpg";